module.exports = __webpack_public_path__ + "img/pack-title03.8bd75e74.png";